let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ccobK")).then(() => parcelRequire('gu7eh'));